import ApiRequestBuilder from '../ApiService/Request/ApiRequestBuilder';


const API_PATH_PUBLIC_BASE = '/public';

const API_PATH_PUBLIC_DATA = `${API_PATH_PUBLIC_BASE}/data`;


class PublicApiService {

    /**
     * @type {ApiService}
     */
    apiService;


    /**
     * @param apiService {ApiService}
     */
    constructor(apiService) {

        this.apiService = apiService;
    }


    /**
     * @parma providerId {string} Payment provider id
     * @return {Promise<object>} Public data
     */
    async getPublicData() {

        const publicDataApiRequest = ApiRequestBuilder.get(API_PATH_PUBLIC_DATA)
            .json()
            .build();

        try {
            const response = await this.apiService.execute(publicDataApiRequest);

            // never fail, it's public API
            if (response.isErroneous()) {

                return {};
            }

            return response.getBody();

        } catch (error) {

            return {};
        }
    }
}

export default PublicApiService;
